import React from 'react'

import * as Yup from 'yup'
import { Form, Select, Input } from 'formik-antd'
import { Tooltip } from 'antd'

import { EyeOutlined } from '@ant-design/icons'

import { BasicForm } from '../../../../core/components/form'
import { useUpdateSmtp, useFetch } from '../../../../hooks/admin/settings/smtp'
import { useHistory } from 'react-router-dom'
import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

const ValidationSchema = Yup.object().shape({
  transport: Yup.string().required('Cannot be blank.'),
  host: Yup.string().required('Cannot be blank.'),
  user: Yup.string().required('Cannot be blank.'),
  password: Yup.string().required('Cannot be blank.'),
  port: Yup.number().integer().typeError('Must be a integer.').required('Cannot be blank.'),
  encryption: Yup.string().required('Cannot be blank.'),
  cc_email: Yup.string().email().typeError('Must be a valid email.')
})

const Formulario = () => {
  const { data, isLoading, isError } = useFetch()
  const update = useUpdateSmtp()
  const history = useHistory()

  function handleSubmit (values, bag) {
    const form = { ...values }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const initialValues = {
    transport: data.entity?.transport,
    host: data.entity?.host,
    user: data.entity?.user,
    password: data.entity?.password,
    port: data.entity?.port,
    encryption: data.entity?.encryption,
    cc_email: data.entity?.cc_email
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='SMTP'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={() => (
        <>
          <Form.Item label='Transport' name='transport' required>
            <Select name='transport' style={{ width: '100%' }}>
              <Select.Option value='smtp'>SMTP</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name='host' label='Host' required>
            <Input name='host' />
          </Form.Item>
          <Form.Item name='user' label='User' required>
            <Input name='user' password />
          </Form.Item>
          <Form.Item name='password' label='Password' required>
            <Input.Password name='password' />
          </Form.Item>
          <Form.Item name='port' label='Port' required>
            <Input name='port' />
          </Form.Item>
          <Form.Item label='Encryption' name='encryption' required>
            <Select name='encryption' style={{ width: '100%' }} required>
              <Select.Option value='tls'>TLS</Select.Option>
              <Select.Option value='ssl'>SSL</Select.Option>
              <Select.Option value='null'>No encryption</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name='cc_email'
            label={
              <Tooltip title='This address will be on CC on every email sent by the system.'>
                <EyeOutlined />
                <span>CC Email</span>
              </Tooltip>
            }
            required
          >
            <Input name='cc_email' />
          </Form.Item>
        </>
      )}
    />
  )
}

export default Formulario
